import React, { useEffect, useState } from "react";
import { Stack, Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useResponsive from "../../hooks/useResponsive";
import Header from "../../layout/dashboard/header";
import ProfileContent from "../../components/profile/ProfileContent";
import { useNotificationService } from "../../components/notification";
import { useAuth } from "../../hooks/useAuth";
import { useMutation } from "@tanstack/react-query";
import { apiGetUser } from "../../api/users";
import {
  UserDataPropsType,
  UserDataPropsTypeDummy,
} from "../../interface/users";

const Profile = () => {
  const theme = useTheme();
  const isMedium = useResponsive("down", "md", "xl");
  const { showNotification } = useNotificationService();
  const { user } = useAuth();
  const [user_info, setUser_info] = useState<UserDataPropsType>(
    UserDataPropsTypeDummy,
  );

  useEffect(() => {
    const userId = user?._id ?? "";
    mutation.mutate({ userId });
  }, []);

  const mutation = useMutation({
    mutationFn: (field: { userId: string }) => apiGetUser(field),
    onSuccess: (data) => {
      if (data?.status === "error") {
        if ("msg" in data) {
          showNotification(data?.msg ?? "", "error");
          return;
        }
        return;
      }
      if ("data" in data) {
        setUser_info(data?.data?.data);
      }
    },
    onError: (error) => {
      console.error("Fetch user details failed", error);
      showNotification("Fetch user details failed", "error");
    },
  });

  return (
    <>
      {/* Header Menu */}
      <Header>
        <Box
          sx={{
            flexGrow: 1,
            display: "flex",
            flexDirection: "row",
            gap: "10px",
            justifyContent: "space-between",
            alignItems: "center",
            marginRight: "1rem",
            height: isMedium ? 60 : 75,
          }}
        >
          <Stack direction={"row"} alignItems={"center"} sx={{ gap: "10px" }}>
            <Typography
              variant={"subtitle1"}
              sx={{
                fontWeight: 500,
                fontFamily: "Lexend",
                color: theme.palette.secondary.dark,
              }}
            >
              Profile
            </Typography>
          </Stack>
        </Box>
      </Header>

      <ProfileContent user_info={user_info} />
    </>
  );
};

export default Profile;
